@use "styles/mixins/_rem.scss" as rem;
@use "styles/mixins/_fonts.scss" as fonts;
@use "styles/mixins/_outline.scss" as outline;

.banner {
  width: 100%;
  max-width: 100%;
  padding: var(--size-spacing-l);
  border-radius: var(--size-border-radius-m);
  background: var(--color-background-info);
  color: var(--color-text-brand-primary);
  white-space: pre-line;
}

.success {
  background: var(--color-background-success);
  border-color: var(--color-border-success);
  color: var(--color-icon-success);
}

.warning {
  background: var(--color-background-warning);
  border-color: var(--color-border-warning);
  color: var(--color-icon-warning);
}

.error {
  background: var(--color-background-error);
  border-color: var(--color-border-error);
  color: var(--color-icon-error);
}

.inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header {
  width: fit-content;
  margin-bottom: var(--size-spacing-xs);
}

.info {
  flex-shrink: 0;
  height: rem.torem(24px);
}

.title {
  @include fonts.body-accent-s;

  color: var(--color-text-default);
  width: 100%;

  &-large {
    @include fonts.body-accent;
  }

  &:not(:last-child) {
    margin-bottom: var(--size-spacing-xs);
  }
}

.content {
  display: flex;
  align-items: stretch;
  height: 100%;
  gap: var(--size-spacing-l);
}

.content-body {
  @include fonts.body-s;

  display: flex;
  flex-direction: column;
  color: var(--color-text-default);

  .description {
    @include fonts.body-s;

    margin: 0;

    &-paragraph {
      @include fonts.body-s;
    }
  }

  &-large,
  &-large .description {
    @include fonts.body;
  }
}

.actions-list {
  margin-top: var(--size-spacing-s);
  display: flex;
  flex-direction: column;
  gap: var(--size-spacing-xs);
}

.close-button {
  height: fit-content;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;

  &-icon {
    width: rem.torem(24px);
  }

  &:focus-within {
    @include outline.focus-outline(rem.torem(4px));

    border-radius: var(--size-border-radius-s);
  }
}

.image {
  max-width: 30%;
  border-radius: var(--size-border-radius-m);
  aspect-ratio: 208/315;
  object-fit: contain;
}
